import { render, staticRenderFns } from "./PartnersList.vue?vue&type=template&id=3997cb8f&scoped=true"
import script from "./PartnersList.vue?vue&type=script&lang=js"
export * from "./PartnersList.vue?vue&type=script&lang=js"
import style0 from "./PartnersList.vue?vue&type=style&index=0&id=3997cb8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3997cb8f",
  null
  
)

export default component.exports